// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2-Ynp","paramInput":"JobSimulator_paramInput__2bKu6","input":"JobSimulator_input__1wlY_"};